/*
  Navigation Bar component using React Bootstrap
*/

import React, { useState } from 'react'
import { Navbar, Nav, Container, Image } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import Logo from '../../assets/images/fullstackcash-Grey.png'

function NavBar () {
  const [expanded, setExpanded] = useState(false)

  const handleToggleMenu = () => {
    setExpanded(false)
  }

  return (
    <Navbar
      expanded={expanded}
      onToggle={setExpanded}
      expand='lg'
      bg='dark'
      variant='dark'
      className='sticky-top'
    >
      <Container>
        <Navbar.Brand as={NavLink} to='/' onClick={handleToggleMenu}>
          <Image src={Logo} alt='FullStack.cash' height='40' className='me-2' />
          FullStack.cash
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='me-auto'>
            <Nav.Link
              as={NavLink}
              to='/'
              onClick={handleToggleMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to='/blog'
              onClick={handleToggleMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Blog
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to='/apis'
              onClick={handleToggleMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              APIs
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to='/pricing'
              onClick={handleToggleMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Private Infra
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to='/cash-box'
              onClick={handleToggleMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Cash Box
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default NavBar
